// src/components/Landing/TermsOfService.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      {/* Header Navigation */}
      <nav className="terms-nav">
        <div className="terms-nav-content">
          <Link to="/" className="terms-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </Link>
          <Link to="/" className="terms-back-btn">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span>Voltar ao Site</span>
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="terms-hero">
        <div className="terms-hero-content">
          <h1>Termos de Uso</h1>
          <p>Conheça os termos e condições para uso da plataforma DRE Pro</p>
          <div className="terms-meta">
            <span className="terms-version">Versão 1.0</span>
            <span className="terms-date">Última atualização: Janeiro de 2025</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="terms-content">
        <div className="terms-container">
          {/* Table of Contents */}
          <aside className="terms-toc">
            <h3>Índice</h3>
            <ul>
              <li><a href="#definitions">1. Definições e Aceite</a></li>
              <li><a href="#service">2. Descrição do Serviço</a></li>
              <li><a href="#registration">3. Registro e Conta</a></li>
              <li><a href="#usage">4. Uso Aceitável</a></li>
              <li><a href="#privacy">5. Privacidade e Dados</a></li>
              <li><a href="#billing">6. Planos e Pagamentos</a></li>
              <li><a href="#intellectual">7. Propriedade Intelectual</a></li>
              <li><a href="#liability">8. Limitações de Responsabilidade</a></li>
              <li><a href="#support">9. Suporte Técnico</a></li>
              <li><a href="#modifications">10. Modificações dos Termos</a></li>
              <li><a href="#termination">11. Rescisão</a></li>
              <li><a href="#compliance">12. Conformidade Legal</a></li>
              <li><a href="#general">13. Disposições Gerais</a></li>
              <li><a href="#contact">14. Contato</a></li>
            </ul>
          </aside>

          {/* Terms Content */}
          <article className="terms-article">
            <section id="definitions" className="terms-section">
              <h2>1. DEFINIÇÕES E ACEITE</h2>
              <p>
                Bem-vindo ao <strong>DRE Pro</strong>, uma plataforma de gestão financeira e contábil 
                desenvolvida para auxiliar empresas e profissionais autônomos no controle de suas finanças.
              </p>
              <p>
                Ao acessar, registrar-se ou utilizar nossos serviços, você concorda integralmente com 
                estes Termos de Uso. Caso não concorde com qualquer disposição aqui estabelecida, 
                não utilize nossa plataforma.
              </p>
              
              <h3>1.1 Definições</h3>
              <ul>
                <li><strong>"DRE Pro"</strong>, <strong>"Plataforma"</strong>, <strong>"Serviço"</strong> ou <strong>"nós"</strong>: refere-se à aplicação web e seus serviços</li>
                <li><strong>"Usuário"</strong> ou <strong>"você"</strong>: pessoa física ou jurídica que utiliza nossos serviços</li>
                <li><strong>"Conta"</strong>: perfil de acesso criado pelo usuário na plataforma</li>
                <li><strong>"Dados Financeiros"</strong>: informações bancárias, transações e relatórios processados pela plataforma</li>
              </ul>
            </section>

            <section id="service" className="terms-section">
              <h2>2. DESCRIÇÃO DO SERVIÇO</h2>
              <p>O DRE Pro é uma plataforma SaaS (Software as a Service) que oferece:</p>
              <div className="terms-features">
                <div className="terms-feature">
                  <h4>Dashboard financeiro</h4>
                  <p>com métricas em tempo real</p>
                </div>
                <div className="terms-feature">
                  <h4>Importação de extratos bancários</h4>
                  <p>(arquivos OFX)</p>
                </div>
                <div className="terms-feature">
                  <h4>Categorização automática</h4>
                  <p>de transações</p>
                </div>
                <div className="terms-feature">
                  <h4>Relatórios DRE</h4>
                  <p>(Demonstração do Resultado do Exercício)</p>
                </div>
                <div className="terms-feature">
                  <h4>Gráficos e análises</h4>
                  <p>comparativas</p>
                </div>
                <div className="terms-feature">
                  <h4>Gestão de múltiplos períodos</h4>
                  <p>e perfis empresariais</p>
                </div>
              </div>
            </section>

            <section id="registration" className="terms-section">
              <h2>3. REGISTRO E CONTA DO USUÁRIO</h2>
              
              <h3>3.1 Elegibilidade</h3>
              <p>Para utilizar o DRE Pro, você deve:</p>
              <ul>
                <li>Ter pelo menos 18 anos de idade</li>
                <li>Fornecer informações verdadeiras e atualizadas</li>
                <li>Possuir capacidade legal para firmar contratos</li>
              </ul>

              <h3>3.2 Responsabilidades da Conta</h3>
              <ul>
                <li>Manter a confidencialidade de suas credenciais de acesso</li>
                <li>Notificar imediatamente sobre uso não autorizado</li>
                <li>Ser responsável por todas as atividades em sua conta</li>
                <li>Manter seus dados de contato atualizados</li>
              </ul>

              <h3>3.3 Múltiplos Perfis</h3>
              <div className="terms-plans">
                <div className="terms-plan">
                  <h4>Plano Personal</h4>
                  <p>1 perfil pessoal</p>
                </div>
                <div className="terms-plan">
                  <h4>Plano Business</h4>
                  <p>1 perfil empresarial</p>
                </div>
                <div className="terms-plan">
                  <h4>Plano Business Pro</h4>
                  <p>múltiplos perfis empresariais + 1 perfil pessoal</p>
                </div>
              </div>
            </section>

            <section id="usage" className="terms-section">
              <h2>4. USO ACEITÁVEL</h2>
              
              <div className="terms-usage-grid">
                <div className="terms-usage-allowed">
                  <h3>4.1 Uso Permitido ✓</h3>
                  <ul>
                    <li>Gestão financeira legítima de seu negócio ou finanças pessoais</li>
                    <li>Geração de relatórios contábeis</li>
                    <li>Análise de dados financeiros próprios</li>
                  </ul>
                </div>
                
                <div className="terms-usage-prohibited">
                  <h3>4.2 Uso Proibido ✗</h3>
                  <ul>
                    <li>Usar a plataforma para atividades ilegais</li>
                    <li>Tentar acessar dados de outros usuários</li>
                    <li>Realizar engenharia reversa do software</li>
                    <li>Sobrecarregar intencionalmente nossos servidores</li>
                    <li>Revender ou redistribuir nossos serviços</li>
                    <li>Inserir dados falsos ou fraudulentos</li>
                  </ul>
                </div>
              </div>
            </section>

            <section id="privacy" className="terms-section">
              <h2>5. PRIVACIDADE E PROTEÇÃO DE DADOS</h2>
              
              <h3>5.1 Coleta de Dados</h3>
              <p>Coletamos apenas dados necessários para:</p>
              <ul>
                <li>Prestação do serviço contratado</li>
                <li>Suporte técnico</li>
                <li>Melhorias na plataforma</li>
                <li>Cumprimento de obrigações legais</li>
              </ul>

              <h3>5.2 Segurança</h3>
              <div className="terms-security">
                <div className="terms-security-item">
                  <h4>🔒 Criptografia</h4>
                  <p>Dados em trânsito e em repouso</p>
                </div>
                <div className="terms-security-item">
                  <h4>🔐 Autenticação</h4>
                  <p>Segura via Firebase</p>
                </div>
                <div className="terms-security-item">
                  <h4>💾 Backup</h4>
                  <p>Automático</p>
                </div>
                <div className="terms-security-item">
                  <h4>🛡️ Monitoramento</h4>
                  <p>Segurança 24/7</p>
                </div>
              </div>

              <h3>5.3 Compartilhamento</h3>
              <div className="terms-highlight">
                <p>
                  <strong>Seus dados financeiros NÃO são compartilhados com terceiros</strong>, exceto:
                </p>
                <ul>
                  <li>Quando exigido por lei</li>
                  <li>Para prestação de suporte técnico (com sua autorização)</li>
                  <li>Para processamento de pagamentos (dados mínimos necessários)</li>
                </ul>
              </div>
            </section>

            <section id="billing" className="terms-section">
              <h2>6. PLANOS E PAGAMENTOS</h2>
              
              <h3>6.1 Planos Disponíveis</h3>
              <div className="terms-pricing">
                <div className="terms-price-card">
                  <h4>Plano Personal</h4>
                  <div className="terms-price">R$ 99<span>/mês</span></div>
                </div>
                <div className="terms-price-card">
                  <h4>Plano Business</h4>
                  <div className="terms-price">R$ 249<span>/mês</span></div>
                </div>
                <div className="terms-price-card">
                  <h4>Plano Business Pro</h4>
                  <div className="terms-price">R$ 399<span>/mês</span></div>
                </div>
              </div>

              <h3>6.2 Faturamento</h3>
              <ul>
                <li>Cobrança mensal via cartão de crédito</li>
                <li>Processamento através do Stripe</li>
                <li>Renovação automática até cancelamento</li>
                <li>Sem taxas de configuração</li>
              </ul>

              <h3>6.3 Cancelamento</h3>
              <div className="terms-cancellation">
                <p>✓ Cancele a qualquer momento entrando em contato com o suporte</p>
                <p>✓ Acesso mantido até o fim do período pago</p>
                <p>✓ Dados preservados por 30 dias após cancelamento</p>
                <p>✓ Sem multas ou taxas de cancelamento</p>
              </div>
            </section>

            <section id="intellectual" className="terms-section">
              <h2>7. PROPRIEDADE INTELECTUAL</h2>
              
              <div className="terms-ip-grid">
                <div className="terms-ip-ours">
                  <h3>7.1 Propriedade do DRE Pro</h3>
                  <ul>
                    <li>Todo o código, design e funcionalidades são de nossa propriedade</li>
                    <li>Protegidos por direitos autorais e outras leis de propriedade intelectual</li>
                    <li>Uso permitido apenas conforme estes termos</li>
                  </ul>
                </div>
                
                <div className="terms-ip-yours">
                  <h3>7.2 Seus Dados</h3>
                  <ul>
                    <li>Você mantém a propriedade de todos os dados inseridos</li>
                    <li>Concede-nos licença limitada para processar esses dados</li>
                    <li>Pode exportar seus dados a qualquer momento</li>
                  </ul>
                </div>
              </div>
            </section>

            <section id="liability" className="terms-section">
              <h2>8. LIMITAÇÕES DE RESPONSABILIDADE</h2>
              
              <h3>8.1 Disponibilidade</h3>
              <ul>
                <li>Meta de 99,9% de disponibilidade</li>
                <li>Manutenções programadas comunicadas com antecedência</li>
                <li>Não garantimos funcionamento ininterrupto</li>
              </ul>

              <h3>8.2 Precisão dos Dados</h3>
              <ul>
                <li>Você é responsável pela veracidade dos dados inseridos</li>
                <li>Relatórios baseados nas informações fornecidas</li>
                <li>Recomendamos validação por contador qualificado</li>
              </ul>

              <div className="terms-warning">
                <h3>8.3 Limitação de Danos</h3>
                <p>
                  Nossa responsabilidade é limitada ao valor pago pelo serviço nos últimos 12 meses. 
                  Não nos responsabilizamos por lucros cessantes, danos indiretos ou consequenciais, 
                  perda de dados por má utilização ou decisões tomadas com base nos relatórios.
                </p>
              </div>
            </section>

            <section id="support" className="terms-section">
              <h2>9. SUPORTE TÉCNICO</h2>
              
              <h3>9.1 Canais de Suporte</h3>
              <div className="terms-support">
                <div className="terms-contact-item">
                  <h4>📱 WhatsApp</h4>
                  <p>+55 41 3798-4531</p>
                </div>
                <div className="terms-contact-item">
                  <h4>📧 Email</h4>
                  <p>suporte@drepro.com.br</p>
                </div>
                <div className="terms-contact-item">
                  <h4>🕒 Horário</h4>
                  <p>Segunda a Sexta, 8h às 18h</p>
                </div>
              </div>

              <h3>9.2 Níveis de Suporte</h3>
              <div className="terms-support-levels">
                <div className="terms-support-level">
                  <h4>Plano Personal</h4>
                  <p>Suporte via WhatsApp</p>
                </div>
                <div className="terms-support-level">
                  <h4>Plano Business</h4>
                  <p>Suporte prioritário</p>
                </div>
                <div className="terms-support-level">
                  <h4>Plano Business Pro</h4>
                  <p>Consultoria dedicada</p>
                </div>
              </div>
            </section>

            <section id="modifications" className="terms-section">
              <h2>10. MODIFICAÇÕES DOS TERMOS</h2>
              <ul>
                <li>Podemos alterar estes termos a qualquer momento</li>
                <li>Usuários serão notificados por email</li>
                <li>Continuidade do uso implica em aceite das alterações</li>
                <li>Prazo mínimo de 30 dias para grandes alterações</li>
                <li>Termos sempre disponíveis na plataforma</li>
                <li>Histórico de versões mantido para transparência</li>
              </ul>
            </section>

            <section id="termination" className="terms-section">
              <h2>11. RESCISÃO</h2>
              
              <div className="terms-termination-grid">
                <div className="terms-termination-user">
                  <h3>11.1 Por Sua Parte</h3>
                  <ul>
                    <li>Cancele a qualquer momento entrando em contato com o suporte</li>
                  </ul>
                </div>
                
                <div className="terms-termination-us">
                  <h3>11.2 Por Nossa Parte</h3>
                  <p>Podemos suspender ou encerrar sua conta em caso de:</p>
                  <ul>
                    <li>Violação destes termos</li>
                    <li>Uso fraudulento ou abusivo</li>
                    <li>Não pagamento (após 7 dias de atraso)</li>
                    <li>Atividades ilegais</li>
                  </ul>
                </div>
              </div>

              <h3>11.3 Efeitos da Rescisão</h3>
              <div className="terms-termination-effects">
                <p>🚫 Acesso imediato suspenso</p>
                <p>💾 Dados preservados por 30 dias</p>
              </div>
            </section>

            <section id="compliance" className="terms-section">
              <h2>12. CONFORMIDADE LEGAL</h2>
              
              <h3>12.1 LGPD</h3>@
              <p>Estamos em conformidade com a Lei Geral de Proteção de Dados:</p>
              <ul>
                <li>Consentimento explícito para coleta de dados</li>
                <li>Direito de acesso, correção e exclusão</li>
                <li>Portabilidade de dados garantida</li>
                <li>DPO disponível para questões de privacidade</li>
              </ul>

              <h3>12.2 Legislação Contábil</h3>
              <ul>
                <li>Relatórios seguem normas contábeis brasileiras</li>
                <li>Não substitui a necessidade de contador profissional</li>
                <li>Ferramenta de apoio à gestão financeira</li>
              </ul>
            </section>

            <section id="general" className="terms-section">
              <h2>13. DISPOSIÇÕES GERAIS</h2>
              
              <h3>13.1 Lei Aplicável</h3>
              <p>Estes termos são regidos pela legislação brasileira, especificamente:</p>
              <ul>
                <li>Código de Defesa do Consumidor</li>
                <li>Marco Civil da Internet</li>
                <li>Lei Geral de Proteção de Dados</li>
              </ul>

              <h3>13.2 Foro</h3>
              <p>Foro da Comarca de Curitiba/PR para dirimir questões relacionadas a estes termos.</p>

              <h3>13.3 Independência das Cláusulas</h3>
              <p>A invalidade de qualquer cláusula não afeta a validade das demais.</p>

              <h3>13.4 Acordo Integral</h3>
              <p>Estes termos constituem o acordo integral entre as partes, substituindo acordos anteriores.</p>
            </section>

            <section id="contact" className="terms-section">
              <h2>14. CONTATO</h2>
              <p>Para questões sobre estes Termos de Uso:</p>
              
              <div className="terms-contact-final">
                <h3>DRE Pro - Gestão Financeira Inteligente</h3>
                <div className="terms-contact-grid">
                  <div className="terms-contact-item">
                    <h4>📱 WhatsApp</h4>
                    <p>+55 41 3798-4531</p>
                  </div>
                  <div className="terms-contact-item">
                    <h4>📧 Email</h4>
                    <p>suportedrepro@gmail.com</p>
                  </div>
                  <div className="terms-contact-item">
                    <h4>🌐 Website</h4>
                    <p>www.drepro.com.br</p>
                  </div>
                </div>
              </div>
            </section>

            <div className="terms-footer-text">
              <p>
                <strong>
                  Ao utilizar o DRE Pro, você confirma ter lido, compreendido e concordado 
                  com todos os termos aqui estabelecidos.
                </strong>
              </p>
              <p className="terms-version-final">Versão 1.0 - Janeiro de 2025</p>
            </div>
          </article>
        </div>
      </main>

      {/* Footer */}
      <footer className="terms-footer">
        <div className="terms-footer-content">
          <Link to="/" className="terms-footer-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </Link>
          <p>&copy; {new Date().getFullYear()} DRE Pro. Todos os direitos reservados.</p>
          <Link to="/" className="terms-footer-back">
            Voltar ao Site Principal
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;